import { Button } from "@/components/ui/button"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { KnowledgebaseFile } from "@/types/knowledgebase"
import { IconTag, IconX } from "@tabler/icons-react"

interface KnowledgebaseUploadBannerProps {
  uploadedFiles: KnowledgebaseFile[]
  onTagFiles: (fileIds: string[]) => void
  onDismiss: () => void
}

export const KnowledgebaseUploadBanner: React.FC<
  KnowledgebaseUploadBannerProps
> = ({ uploadedFiles, onTagFiles, onDismiss }) => {
  const { translate } = useTranslation()
  const count = uploadedFiles.length

  if (count === 0) return null

  return (
    <div className="flex items-center gap-3 rounded-lg border border-yellow1/30 bg-yellow1/10 px-4 py-3">
      <IconTag size={18} className="shrink-0 text-yellow1" />
      <p className="flex-1 text-sm text-grey6">
        {translate("KNOWLEDGEBASE/UPLOAD_BANNER_MESSAGE", { count })}
      </p>
      <Button
        size="sm"
        variant="outline"
        className="shrink-0 border-yellow1/50 text-yellow1 hover:bg-yellow1/10 hover:text-yellow1"
        onClick={() => onTagFiles(uploadedFiles.map((f) => f.id))}
      >
        {translate("KNOWLEDGEBASE/UPLOAD_BANNER_CTA")}
      </Button>
      <Button
        size="icon"
        variant="ghost"
        className="h-7 w-7 shrink-0 text-grey4 hover:text-grey6"
        onClick={onDismiss}
        aria-label={translate("NOTIF/UI/DISMISS")}
      >
        <IconX size={14} />
      </Button>
    </div>
  )
}
